import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Typography, Button, TextField, 
  Container, Grid, Card, CardContent, InputAdornment, Fade
} from '@mui/material';
import { 
  QrCodeScanner, 
  VerifiedUser,
   Pets,  
  ArrowForwardIos,
  InfoOutlined
} from '@mui/icons-material';
import api from '../api/api';
import logo from '../assets/images/logo.png';
import ModalEscaneoRecepcion from './ModalEscaneoRecepcion';

// Importa la imagen del perrito
import perroBalde from '../assets/images/naVtL.jpg';   // ← Cambia la ruta según donde guardes la imagen

// Paleta de colores institucional
const CLINIC_NAVY = '#0f172a';
const CLINIC_BLUE = '#2563eb';
const CLINIC_SLATE = '#64748b';
const INFO_SOFT = '#eff6ff';
const GENERAL_SOFT = '#f8fafc';

const BANNED_WORDS = ['puta', 'mierda', 'pendejo', 'estupido'];

const RecepcionEscannerCamara = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [nombreTemp, setNombreTemp] = useState('');
  const [nombreError, setNombreError] = useState('');

  const [qrManual, setQrManual] = useState('');

  const handleLecturaQR = async (rawText) => {
    let qrCode = rawText.trim();
    if (qrCode.includes('galaxia-alpha.vercel.app')) qrCode = qrCode.split('/').pop();
    else if (qrCode.includes('|')) qrCode = qrCode.split('|')[0];
    qrCode = qrCode.trim().toUpperCase();

    try {
      const response = await api.get(`/pacientes/qr/${qrCode}`);
      setOpenModal(false);
      navigate('/confirmacion-turno', {
        state: {
          qrCode,
          nombrePaciente: response.data.nombre_paciente,
          esManual: false,
          pacienteId: response.data.id_paciente,
        },
      });
    } catch (err) {
      setOpenModal(false);
      const mensajeError = err.response?.status === 404
        ? 'El registro no se encuentra activo o el código es inválido.'
        : 'Error de comunicación con el servidor central.';
      navigate('/error-qr', { state: { message: mensajeError } });
    }
  };

  const handleManualTurno = () => {
    const nombreLimpio = nombreTemp.trim().toLowerCase();
    
    if (!nombreLimpio) return;

    const tienePalabraProhibida = BANNED_WORDS.some(palabra => 
      nombreLimpio.includes(palabra)
    );

    if (tienePalabraProhibida) {
      setNombreError('El término ingresado no cumple con las políticas de la institución.');
      return;
    }

    setNombreError('');
    navigate('/confirmacion-turno', {
      state: { nombrePaciente: nombreTemp.trim(), esManual: true },
    });
  };

  return (
    <Fade in={true} timeout={800}>
      <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', pt: { xs: 2, md: 0 }, pb: { xs: 4, md: 8 } }}>
        <Container maxWidth="lg">
          
          {/* Header Institucional */}
          <Box sx={{ mb: 6, textAlign: 'right', display: 'flex', alignItems: 'center', gap: 3, justifyContent: 'flex-end' }}>
            <img 
              src={logo} 
              alt="Logo Institucional"
              style={{ maxWidth: '220px', height: 'auto' }}
            />
            <Box sx={{ height: '50px', width: '2px', bgcolor: '#e2e8f0', display: { xs: 'none', sm: 'block' } }} />
            
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 800, color: CLINIC_NAVY, letterSpacing: '-0.02em' }}>
                Recepción Digital de Pacientes
              </Typography>
              <Typography variant="body1" sx={{ color: CLINIC_SLATE }}>
                Módulo de Admisión 
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={4} alignItems="stretch">
            
            {/* Opción 1: Escaneo QR */}
            <Grid item xs={12} md={6}>
              <Card sx={{ 
                height: '100%', 
                borderRadius: '20px', 
                boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                transition: '0.3s',
                '&:hover': { transform: 'translateY(-6px)', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.12)' }
              }}>
                <Box sx={{ p: 2, bgcolor: INFO_SOFT, textAlign: 'center', borderBottom: '1px solid #e0f2fe' }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: CLINIC_BLUE, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Identificación Digital
                  </Typography>
                </Box>

                <CardContent sx={{ 
                  p: 5, 
                  flexGrow: 1, 
                  display: 'flex', 
                  flexDirection: 'column',
                  textAlign: 'center' 
                }}>
                  <Box sx={{ 
                    width: 90, height: 90, borderRadius: '50%', bgcolor: '#dbeafe', 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 4 
                  }}>
                    <QrCodeScanner sx={{ fontSize: 48, color: CLINIC_BLUE }} />
                  </Box>

                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: CLINIC_NAVY }}>
                    Paciente con Código QR
                  </Typography>

                  <Typography variant="body2" sx={{ color: CLINIC_SLATE, mb: 5, lineHeight: 1.7, flexGrow: 1 }}>
                    Escanee el código del carnet digital para validar automáticamente los datos clínicos del paciente.
                  </Typography>

                  <Button 
                    variant="contained" 
                    fullWidth 
                    size="large"
                    startIcon={<VerifiedUser />}
                    onClick={() => setOpenModal(true)}
                    sx={{ 
                      borderRadius: '12px', 
                      py: 2.2, 
                      textTransform: 'none', 
                      fontSize: '1.1rem', 
                      bgcolor: CLINIC_BLUE,
                      mt: 'auto',
                      boxShadow: '0 4px 12px rgba(37, 99, 235, 0.25)',
                      '&:hover': { bgcolor: '#1e40af' }
                    }}
                  >
                    Iniciar Escaneo
                  </Button>
                  {/* Separador visual opcional */}
<Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
  <Box sx={{ flex: 1, height: '1px', bgcolor: '#e2e8f0' }} />
  <Typography variant="caption" sx={{ px: 2, color: CLINIC_SLATE }}>O</Typography>
  <Box sx={{ flex: 1, height: '1px', bgcolor: '#e2e8f0' }} />
</Box>

<TextField
  size="small"
  placeholder="Ingresar código manualmente"
  fullWidth
  value={qrManual}
  onChange={(e) => setQrManual(e.target.value)}
  onKeyPress={(e) => {
    if (e.key === 'Enter' && qrManual.trim()) {
      handleLecturaQR(qrManual);
    }
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <Button 
          size="small" 
          onClick={() => handleLecturaQR(qrManual)}
          disabled={!qrManual.trim()}
        >
          Enviar
        </Button>
      </InputAdornment>
    ),
    sx: { borderRadius: '8px', fontSize: '0.9rem' }
  }}
/>

                  


                </CardContent>
              </Card>
            </Grid>

            {/* Opción 2: Ingreso sin Código - Con imagen del perrito */}
            <Grid item xs={12} md={6}>
              <Card sx={{ 
                height: '100%', 
                borderRadius: '20px', 
                boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                transition: '0.3s',
                '&:hover': { transform: 'translateY(-6px)', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.12)' }
              }}>
                <Box sx={{ 
                  p: 2, 
                  bgcolor: GENERAL_SOFT, 
                  textAlign: 'center',
                  borderBottom: '1px solid #e2e8f0'
                }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: CLINIC_SLATE, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Registro General
                  </Typography>
                </Box>

                <CardContent sx={{ 
                  p: 5, 
                  flexGrow: 1, 
                  display: 'flex', 
                  flexDirection: 'column',
                  textAlign: 'center' 
                }}>
                  {/* ← Aquí va la imagen del perrito en lugar del icono */}
                  <Box sx={{ 
                    width: 110, 
                    height: 110, 
                    borderRadius: '50%', 
                    overflow: 'hidden',
                    mx: 'auto', 
                    mb: 4,
                    border: '6px solid #f1f5f9',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                  }}>
                    <img 
                      src={perroBalde} 
                      alt="Perro sin código" 
                      style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'cover' 
                      }} 
                    />
                  </Box>

                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: CLINIC_NAVY }}>
                    Ingreso sin Código
                  </Typography>

                  <Typography variant="body2" sx={{ 
                    color: CLINIC_SLATE, 
                    mb: 4, 
                    lineHeight: 1.7 
                  }}>
                    Registre manualmente el nombre de la mascota o propietario cuando no disponga del código QR.
                  </Typography>

                  <TextField
                    placeholder="Nombre de la mascota o propietario"
                    label="Identificación de Turno"
                    fullWidth
                    variant="outlined"
                    value={nombreTemp}
                    onChange={(e) => {
                      setNombreTemp(e.target.value);
                      if (nombreError) setNombreError('');
                    }}
                    error={!!nombreError}
                    helperText={nombreError}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Pets sx={{ color: CLINIC_SLATE }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ mb: 4, '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                  />

                  <Button
                    variant="outlined" 
                    fullWidth
                    size="large"
                    endIcon={<ArrowForwardIos />}
                    onClick={handleManualTurno}
                    disabled={!nombreTemp.trim()}
                    sx={{ 
                      borderRadius: '12px', 
                      py: 2.2, 
                      textTransform: 'none', 
                      fontSize: '1.1rem', 
                      borderWidth: 2,
                      color: CLINIC_NAVY,
                      borderColor: '#cbd5e1',
                      mt: 'auto',
                      '&:hover': { 
                        borderWidth: 2, 
                        borderColor: CLINIC_NAVY, 
                        bgcolor: '#f8fafc' 
                      }
                    }}
                  >
                    Asignar Turno Manual
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Footer Informativo */}
          <Box sx={{ 
            mt: 8, pt: 4, borderTop: '1px solid #e2e8f0', 
            display: 'flex', flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between', alignItems: 'center', gap: 2
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', color: CLINIC_SLATE }}>
              <InfoOutlined sx={{ fontSize: 18, mr: 1 }} />
              <Typography variant="body2">
                Identificación única para pacientes
              </Typography>
            </Box>
            <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 500 }}>
              Veterinaria Galaxia Doge Places
            </Typography>
          </Box>
        </Container>

        <ModalEscaneoRecepcion 
          open={openModal} 
          onClose={() => setOpenModal(false)} 
          onResult={handleLecturaQR} 
        />
      </Box>
    </Fade>
  );
};

export default RecepcionEscannerCamara;